import { render, staticRenderFns } from "./ViewProject.vue?vue&type=template&id=fa9c4a12&"
import script from "./ViewProject.vue?vue&type=script&lang=js&"
export * from "./ViewProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa9c4a12')) {
      api.createRecord('fa9c4a12', component.options)
    } else {
      api.reload('fa9c4a12', component.options)
    }
    module.hot.accept("./ViewProject.vue?vue&type=template&id=fa9c4a12&", function () {
      api.rerender('fa9c4a12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projectmanagement/ViewProject.vue"
export default component.exports